import {text_mod_59, } from "../text/Text.js";
export const module59 = {
  title:
    "§59. Деформовані речення. Створення речень за малюнками",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_59, },
    ]
  }
